module.exports = __webpack_public_path__ + "static/media/coughing-blood.94ab98b9.svg";